module.exports = __webpack_public_path__ + "static/media/like_enabled.279ec6ba.svg";